// Based on: https://theme-ui.com/theme-spec/
export const theme = {
  /** color, background-color, border-color */
  colors: {
    aqua: '#00e7e8',
    background: '#f8f8f8',
    black: '#000000',
    blue: '#2c00dc',
    darkBlue: '#020250',
    darkGrey: '#1a1a1a',
    green: '#047972',
    lightBlue: '#ede9fe',
    lightGreen: '#a4ffce',
    lightPink: '#ffd9e4',
    neutral: '#e7e5dd',
    neutralLight: '#f1efe9',
    orange: '#dd3900',
    pink: '#e60477',
    purple: '#c934e1',
    white: '#ffffff',
    yellow: '#ffe793',
  },
  /** font-size */
  fontSizes: {
    0: '12',
    1: '14',
    2: '16',
    3: '18',
    4: '20',
    5: '24',
    6: '28',
    7: '32',
    8: '36',
    get default() {
      return this[1];
    },
  },
  /** font-weight */
  fontWeights: {
    light: '300',
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
    extraBold: '800',
    black: '900',
  },
  /** line-height */
  lineHeights: {
    body: '1.6',
    heading: '1.2',
  },
  /** margin, margin-top, margin-right, margin-bottom, margin-left, padding, padding-top, padding-right, padding-bottom, padding-left, grid-gap, grid-column-gap, grid-row-gap */
  space: {
    0: '8px',
    1: '16px',
    2: '24px',
    3: '32px',
    4: '40px',
    5: '48px',
    6: '56px',
    7: '64px',
    8: '72px',
    9: '80px',
    10: '88px',
    11: '96px',
    12: '104px',
    13: '112px',
    14: '120px',
  },
  /** border-radius */
  radii: {},
  /** box-shadow, text-shadow */
  shadows: {},
  /** z-index */
  zIndices: {},
};
